(function ($, document, window, undefined) {

    'use strict';
    
    var Galleries = function() {

      var init = function() {
        
        neighbourhood();
        neighbourhoodHome();
        amenitiesHome();
      }

      var neighbourhood = function() {

        if( $(document).find(".page-template-page-neighbourhood").length ) {

          var galleryThumbs = new Swiper('.gallery-thumbs', {
            spaceBetween: 16,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            loop: true
          });

          var galleryTop = new Swiper('.gallery-top', {
            spaceBetween: 10,
            loop: true,
            autoplay: {
              delay: 9000,
            },
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            thumbs: {
              swiper: galleryThumbs
            }
          });
        }   
      }
      
      var neighbourhoodHome = function() {

        if( $(document).find(".page-template-page-home").length ) {

          var gallery = new Swiper('#neighbourhood .gallery', {
            spaceBetween: 0,
            loop: true,
            autoplay: {
              delay: 5000,
            },
            pagination: {
              el: '#neighbourhood .swiper-pagination',
            },
            navigation: {
              nextEl: '#neighbourhood .swiper-button-next',
              prevEl: '#neighbourhood .swiper-button-prev',
            }
          });
        }
      }

      var amenitiesHome = function() {

        if( $(document).find(".page-template-page-home").length ) {

          var gallery = new Swiper('#amenities .gallery', {
            spaceBetween: 10,
            loop: true,
            autoplay: {
              delay: 9000,
            },
            pagination: {
              el: '#amenities .swiper-pagination',
            },
            navigation: {
              nextEl: '#amenities .swiper-button-next',
              prevEl: '#amenities .swiper-button-prev',
            }
          });
        }
      }
      
      return { init }
    }();

    if (!window.Frontier) window.Frontier = {};
      window.Frontier.Galleries = Galleries;

}(jQuery, document, window, undefined));

